<h2 *ngIf="isNewAccount" mat-dialog-title>Add User to {{selectedAccount.accountName}}</h2>
<h2 *ngIf="!isNewAccount" mat-dialog-title>Manage User for {{selectedAccount.accountName}}</h2>
<mat-dialog-content>
  <form>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column" *ngIf="users">
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-form-field style="padding-left: 1%; width: 98%;">
          <input matInput placeholder="Search" #searchBox id="search-box" (keyup)="updateSearch(searchBox.value)" />
          <button mat-icon-button id="clearSearch" *ngIf="searchBox.value" matSuffix aria-label="Clear" (click)="searchBox.value=''; updateSearch(searchBox.value)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-selection-list class="list" style="text-align: left;" (selectionChange)="changeUserIds($event)">
          <cdk-virtual-scroll-viewport itemSize="48" style="height:100%">
              <mat-list-option *cdkVirtualFor="let user of filterUsers(users); templateCacheSize: 0" [value]="user.id" [selected]="selection.isSelected(user.id)"> 
                <span matListItemTitle style="display: flex; align-items: center;">{{user.userName}}</span>
              </mat-list-option>
          </cdk-virtual-scroll-viewport>
        </mat-selection-list>
        </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitUserAccountAccessFormForm" [disabled]="!formChanged" (click)="submit()">Submit</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
